import HospitalUserProfileDTO from '@src/adapters/dto/hospital/HospitalUserProfileDTO';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  userId: string;
  hospitalId: string;
}

type Result = HospitalUserProfileDTO;

const options: ApiOptions = {
  method: 'get',
  urlPath: '/hospital/user',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindHospitalUser = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useFindHospitalUserLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindHospitalUser;
